export default "__VITE_ASSET__dSQKj$KP__"